module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-06.397bf082.png";